import React, {useCallback} from 'react';
import {RadiusView} from 'src/res/Radius';
import {FontWeightMedium} from 'src/res/FontWeight';
import {locString} from "../commons/ViewHelper";
import View from "../commons/View";
import TouchableOpacity from "../commons/TouchableOpacity";
import ImageBackground from "../commons/ImageBackground";
import AppImage from "../commons/AppImage";
import CircularProgress from "@material-ui/core/CircularProgress";
import AppUtils, {dispatchSimulationClick} from "../../utils/AppUtils";
import GameAudio from "../commons/GameAudio";
import {
  GAME_LOSE_AUDIO,
  GAME_NEUTRAL_AUDIO,
  GAME_PLAY_AUDIO,
  GAME_TIMER_AUDIO,
  GAME_WIN_AUDIO
} from "../../utils/GameAudioPlayer";
import AppText from "../commons/AppText";
import {ColorBlack, ColorClear, ColorGreen, ColorWhite} from "src/styles/Colors";
import {Skeleton} from "@material-ui/lab";

export default class TicTacToeGameView extends React.Component {

    constructor(props) {
        super(props);
        this.onLose = props.onLose;
        this.onWin = props.onWin;
        this.gameStartTime = null;
        this.actionDisabled = false;

        this.state = {
            reload: false,
            play: true,
            board: Array(9).fill(null),
            winIndexes: null,
            winPlayer: null,
            isDraw: false
        };
        this.setupWith(props.items);
    }

    componentDidMount() {
        this.showGameFinishDummyView();
    }

    componentWillUnmount() {
        if (this.intervalFunc) {
            clearInterval(this.intervalFunc);
        }
        this.stopGameTimerAudio();

      for (let i = 0; i < this.state.board.length; i++) {
        this['refCard'+ i] = null;
      }
    }

    simulatePlay = () => {
      let firstDelay = 0;
      if (this.props.roundsPlayed > 0) {
        firstDelay = 3000;
      }

      setTimeout(() => {
        const randomIndex = Math.floor(Math.random() * 100 % 9);
        dispatchSimulationClick(this['refCard'+ randomIndex]);
      }, firstDelay);
    }

    playUserAuto = () => {
      setTimeout(() => {
        // const {board} = this.state;
        // const emptyPlaces = [];
        // for (let i = 0; i < board.length; i++) {
        //   if (!board[i]) {
        //     emptyPlaces.push(i);
        //   }
        // }
        const index = this.getUserPosition();
        dispatchSimulationClick(this['refCard'+ index]);
      }, 1000);
    }

    resetForPreview(items) {
        this.setupWith(items);
    }

    reset(items) {
        const currentTime = new Date().getTime();
        const idleTime = 2 * 1000;
        const resetAfter = Math.max(0, idleTime - (currentTime - this.endGameProcessStartTime));

        setTimeout(() => {
            this.actionDisabled = false;
            this.setState({
                play: true,
                board: Array(9).fill(null),
                winIndexes: null,
                winPlayer: null,
                isDraw: false
            });
            this.setupWith(items);

            this.showGameFinishDummyView();
        }, resetAfter);
    }

    setupWith(items) {
        this.items = items;
        if (this.items && this.items.length > 0) {
            this.playerUser = this.items[0];
            if (this.items.length > 1) {
                this.playerAI = this.items[1];
            }
        }
        if (!this.playerUser) {
            this.playerUser = {
                id: -10,
            }
        }
        if (!this.playerUser.id) {
            this.playerUser.id = -10;
        }
        if (!this.playerUser.imageUrl) {
          this.playerUser.image = require('src/images/activityGameTicTacToe/27-img_o.png');
        }

        if (!this.playerAI) {
            this.playerAI = {
                id: -1,
            }
        }
        if (!this.playerAI.id) {
          this.playerAI.id = -1;
        }
        if (!this.playerAI.imageUrl) {
            this.playerAI.image = require('src/images/activityGameTicTacToe/27-img_x.png');
        }

        this.gameStartTime = null;
    }

    showGameFinishDummyView() {
        if (this.props.disabled && (this.props.userWonRounds >= this.props.roundsToWin || this.props.aiWonRounds >= this.props.roundsToWin)) {
            if (this.props.userWonRounds >= this.props.roundsToWin) {
                this.setState({board: [
                        this.playerAI.id, this.playerUser.id, this.playerAI.id,
                        this.playerUser.id, this.playerUser.id, this.playerUser.id,
                        this.playerAI.id, this.playerUser.id, this.playerAI.id,
                    ]});
            } else {
                this.setState({board: [
                        this.playerUser.id, this.playerAI.id, this.playerUser.id,
                        this.playerAI.id, this.playerAI.id, this.playerAI.id,
                        this.playerUser.id, this.playerAI.id, this.playerUser.id,
                    ]});
            }
        }
    }

    playGamePlayAudio() {
        if (this.gamePlayAudioId) {
            this.gamePlayAudioId.play();
        }
    }

    playGameTimerAudio() {
        if (this.gameTimerAudioId) {
            this.gameTimerAudioId.play();
        }
    }

    stopGameTimerAudio() {
        if (this.gameTimerAudioId) {
            this.gameTimerAudioId.pause();
        }
    }

    render() {
        const uiConfigs = this.props.uiConfigs;
        const sizeFactor = uiConfigs.sizeFactor;
        const isDisabled = this.props.disabled;
        const rows = this.props.rows;
        const columns = this.props.columns;

        const cardSize = this.getCardSize();
        const cardSpacing = this.getCardSpacing();
        const allFlipsWidth = (cardSize + cardSpacing) * columns + 1;
        const allFlipsHeight = (cardSize + cardSpacing) * rows + 1;
        const flipBgMargin = uiConfigs.flipBgMarginStartEnd * sizeFactor;
        const flipBgMarginTop = uiConfigs.flipBgMarginStartEnd * sizeFactor;
        const flipBgMarginBottom = uiConfigs.flipBgMarginStartEnd * sizeFactor;

        // let gameTimeLeft = this.props.gameTime/1000;
        // if (this.gameStartTime) {
        //     const nowTimer = new Date().getTime();
        //     gameTimeLeft = Math.max(0, parseInt((this.props.gameTime - (nowTimer - this.gameStartTime))/1000));
        // }

        return (
            <View style={{alignItems: 'center', paddingBottom: uiConfigs.collectionImage ? 28 * sizeFactor : 0}}>
              {!this.props.disableAudio ?
                <div>
                    <GameAudio ref={(ref) => this.gamePlayAudioId = ref} source={this.props.gamePlayAudioUrl || GAME_PLAY_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                    <GameAudio ref={(ref) => this.gameTimerAudioId = ref} source={GAME_TIMER_AUDIO} autoPlay={false} loop={true} hasUserInteraction={true} mute={this.props.mute} />
                    <GameAudio ref={(ref) => this.gamePlayAudioIdLose = ref} source={this.props.gameLoseAudioUrl || GAME_LOSE_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                    <GameAudio ref={(ref) => this.gamePlayAudioIdWin = ref} source={this.props.gameWinAudioUrl || GAME_WIN_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                    <GameAudio ref={(ref) => this.gamePlayAudioIdNeutral = ref} source={GAME_NEUTRAL_AUDIO} autoPlay={false} loop={false} hasUserInteraction={true} mute={this.props.mute} />
                </div>
                : null
              }
                <ImageBackground source={uiConfigs.gameBgTopImage} resizeMode="fill" style={{height: 40 * sizeFactor, minWidth: 180 * sizeFactor, display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{position: 'relative', fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, marginLeft: 8 * sizeFactor, marginRight: 8 * sizeFactor, marginBottom: 2 * sizeFactor}}>
                        {locString('roundInfo', {value1: this.props.roundsPlayed, value2: this.props.rounds})}
                    </AppText>
                </ImageBackground>

                <PlayerScoreView
                  uiConfigs={uiConfigs}
                  isLTR={this.props.isLTR}
                  playerUser={this.playerUser}
                  playerAI={this.playerAI}
                  onImageClicked={this.props.onImageClicked}
                  userWonRounds={this.props.userWonRounds}
                  aiWonRounds={this.props.aiWonRounds}
                  fetchingAi={this.state.fetchingAi}
                  showFetchLoading={!isDisabled && !this.state.isDraw && !this.state.winPlayer}
                />

                <ImageBackground source={uiConfigs.gameBgImage} resizeMode="stretch" style={{flexDirection: 'row', flexWrap: 'wrap', height: allFlipsHeight + flipBgMarginTop + flipBgMarginBottom, width: allFlipsWidth + 2 * flipBgMargin, display: 'flex', padding: flipBgMargin, paddingTop: flipBgMarginTop, paddingBottom: flipBgMarginBottom, overflow: 'hidden', opacity: isDisabled ? 0.8 : 1}}>
                    <CardsView
                      refTouch={this.onRefTouch}
                      disabled={isDisabled || this.actionDisabled}
                      uiConfigs={uiConfigs}
                      cardSize={cardSize}
                      onClick={this.movePlayerUser}
                      winIndexes={this.state.winIndexes}
                      board={this.state.board}
                      playerUser={this.playerUser}
                      playerAI={this.playerAI}
                    />
                    {this.state.isDraw || this.state.winPlayer ?
                        <View style={{position: 'absolute', top: 0, bottom: 0, right: 0, left: 0, alignItems: 'center', justifyContent: 'center'}}>
                            <View style={{alignItems: 'center'}}>
                                <View style={{padding: 8, paddingLeft: 16, paddingRight: 16, marginBottom: 4, backgroundColor: AppUtils.colorWithAlpha(uiConfigs.messageBgColor, 0.9), borderRadius: 20}}>
                                    <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{color: uiConfigs.overlayTitleColor, fontWeight: FontWeightMedium}}>
                                        {this.state.isDraw ? locString('activity.roundDraw') : (this.state.winPlayer.id === this.playerUser.id ? locString(this.props.disabled ? 'youWon' : 'activity.roundWon') : locString(this.props.disabled ? 'youLost' : 'activity.roundLost'))}
                                    </AppText>
                                </View>
                              {!this.props.simulation ?
                                <CircularProgress size={uiConfigs.fontSize * 2} style={{color: uiConfigs.messageBgColor}} />
                                : null
                              }
                            </View>
                        </View>
                        : null
                    }
                </ImageBackground>
            </View>
        );
    }

    onRefTouch = (ref, index) => {
      this['refCard'+ index] = ref;
    }

    movePlayerUser = (index) => {
        if (this.props.noActionMode) {
          this.props.onActionClickedInNoActionMode();
          return;
        }

        const board = this.state.board;
        let isStart = true;
        board.forEach((boardIndex) => {
          if (boardIndex) {
            isStart = false;
          }
        });
        if (isStart) {
          if (this.props.onStart) {
            this.props.onStart();
          }
        }

        if (board[index]) {
            return;
        }

        if (this.actionDisabled) {
            return;
        }
        this.actionDisabled = true;

        board[index] = this.playerUser.id;
        this.setState({board}, () => {
          this.processUserActionNMovePlayerAi();
        });
        this.playGamePlayAudio();
    };

    refreshGame(gameData) {
      const newBoardLength = gameData.state ? gameData.state.length : 0;
      const oldBoardLength = this.state.board ? this.state.board.length : 0;
      if (newBoardLength && oldBoardLength) {
        this.playGamePlayAudio();
      }
      this.setState({board: gameData.state, fetchingAi: false}, () => {
        if (!this.processGameResult(gameData)) {
          this.actionDisabled = false;
          this.setState({reload: !this.state.reload}, () => {
            if (this.props.autoSimulation) {
              this.playUserAuto();
            }
          });
        }
      });
    }

    onFetchDone = (gameData) => {
      this.refreshGame(gameData);
    }

    processUserActionNMovePlayerAi() {
      this.setState({fetchingAi: true}, () => {
        setTimeout(() => {
          const gameData = {
            input: [{id: this.playerUser.id}, {id: this.playerAI.id}],
            state: this.state.board,
          };
          if (this.props.fetchAction) {
            this.props.fetchAction({gameData}, this.onFetchDone);
            return;
          }
          this.fetchAIPosition(gameData, this.onFetchDone);
        }, this.props.autoSimulation ? 600 : 200);
      });
    }

    fetchAIPosition(gameData, onDone) {
      // check result for player user action
      const board = gameData.state;
      const gameResultUser = this.fetchGameResult(board, this.playerUser.id);
      if (gameResultUser) {
         onDone({
           state: board,
           result: gameResultUser.result,
           resultVal: gameResultUser.resultVal,
         });
         return;
      }

      // find player ai position
      let index = -1;
      const reboard = [];
      for (let i = 0; i < board.length; i++) {
        if (board[i] === this.playerUser.id || board[i] === this.playerAI.id) {
          reboard.push(board[i]);
        } else {
          reboard.push(i);
        }
      }

      let playDumb = this.props.easy && parseInt((Math.random() * 100)) > 100 - this.props.easy;
      if (playDumb) {
        const array = this.emptyIndexes(reboard);
        let possiblePos = [0, 2, 6, 8, 1, 3, 5, 7];
        possiblePos = possiblePos.filter(value => array.includes(value));
        if (possiblePos.length > 0) {
          index = possiblePos[parseInt((Math.random() * 100)) % possiblePos.length];
        }
      }

      if (index === -1) {
        index = this.minimax(reboard, this.playerAI.id).index;
      }
      board[index] = this.playerAI.id;
      // check result for player bot action
      const gameResultUserBot = this.fetchGameResult(board, this.playerAI.id);
      onDone({
        state: board,
        result: gameResultUserBot ? gameResultUserBot.result : 0,
        resultVal: gameResultUserBot ? gameResultUserBot.resultVal : null,
      });
    }

  getUserPosition() {
    // check result for player bot action
    const gameData = {
      input: [{id: this.playerUser.id}, {id: this.playerAI.id}],
      state: this.state.board,
    };
    const board = gameData.state;

    // find player user position
    let index = -1;
    const reboard = [];
    for (let i = 0; i < board.length; i++) {
      if (board[i] === this.playerAI.id || board[i] === this.playerUser.id) {
        reboard.push(board[i]);
      } else {
        reboard.push(i);
      }
    }

    let playDumb = parseInt((Math.random() * 100)) > 40;
    if (playDumb) {
      const array = this.emptyIndexes(reboard);
      let possiblePos = [0, 2, 6, 8, 1, 3, 5, 7];
      possiblePos = possiblePos.filter(value => array.includes(value));
      if (possiblePos.length > 0) {
        index = possiblePos[parseInt((Math.random() * 100)) % possiblePos.length];
      }
    }

    if (index === -1) {
      index = this.minimax(reboard, this.playerUser.id).index;
    }
    return index;
  }

    areTriesComplete(board) {
        let playTurn = 0;
        for (let i = 0; i < board.length; i++) {
            if (board[i]) {
                playTurn++;
            }
        }
        return playTurn === 9;
    }

    minimax(reboard, playerId, depth = 0) {
        depth++;
        let array = this.emptyIndexes(reboard);
        if (this.winning(reboard, this.playerUser.id).isWin) {
            return {
                score: -10 + depth
            };
        } else if (this.winning(reboard, this.playerAI.id).isWin) {
            return {
                score: 10 - depth
            };
        } else if (array.length === 0) {
            return {
                score: 0
            };
        }

        const moves = [];
        for (let i = 0; i < array.length; i++) {
            let move = {};
            move.index = reboard[array[i]];
            reboard[array[i]] = playerId;

            if (playerId === this.playerAI.id) {
                const g = this.minimax(reboard, this.playerUser.id, depth);
                move.score = g.score;
            } else {
                const g = this.minimax(reboard, this.playerAI.id, depth);
                move.score = g.score;
            }
            reboard[array[i]] = move.index;
            moves.push(move);
        }

        const indexes = [];
        if (playerId === this.playerAI.id) {
            let bestScore = -10000;
            moves.forEach((move) => {
                if (move.score > bestScore) {
                    bestScore = move.score;
                }
            });
            for (let i = 0; i < moves.length; i++) {
                if (moves[i].score >= bestScore) {
                    indexes.push(i);
                }
            }
        } else {
            let bestScore = 100000;
            moves.forEach((move) => {
                if (move.score < bestScore) {
                    bestScore = move.score;
                }
            });
            for (let i = 0; i < moves.length; i++) {
                if (moves[i].score <= bestScore) {
                    indexes.push(i);
                }
            }
        }

        let bestMove;
        // play at position which can be directly be winner
        if (depth === 1) {
            const score = moves[indexes[0]].score;
            if (score < 0) {
                for (let i = 0; i < indexes.length; i++) {
                    const move = moves[indexes[i]];
                    const oldValue = reboard[move.index];
                    reboard[move.index] = this.playerUser.id;
                    if (this.winning(reboard, this.playerUser.id).isWin) {
                        bestMove = i;
                    }
                    reboard[move.index] = oldValue;
                    if (bestMove) {
                        break;
                    }
                }
            }
        }
        if (!bestMove) {
            bestMove = indexes[parseInt(Math.random() * 100) % indexes.length];
        }

        return moves[bestMove];
    }

    emptyIndexes(reboard) {
        return reboard.filter(item => item !== this.playerUser.id && item !== this.playerAI.id);
    }

    winning(board, playerId) {
        const winResult = {
            isWin: false,
            winIndexes: null,
        };
        const winChecks = [
            [0, 1, 2],
            [3, 4, 5],
            [6, 7, 8],
            [0, 3, 6],
            [1, 4, 7],
            [2, 5, 8],
            [0, 4, 8],
            [2, 4, 6],
        ];
        for (let i = 0; i < winChecks.length; i++) {
            const [a, b, c] = winChecks[i];
            if (board[a] === playerId && board[b] === playerId && board[c] === playerId) {
                winResult.isWin = true;
                winResult.winIndexes = winChecks[i];
                break;
            }
        }
        return winResult;
    }

    fetchGameResult(board, playerId) {
      const winningResult = this.winning(board, playerId);
      if (winningResult.isWin) {
        return {
          result: playerId === this.playerUser.id ? 1 : 2,
          resultVal: winningResult.winIndexes,
        };
      } else if (this.areTriesComplete(board)) {
        return {
          result: 3,
        };
      }
      return null;
    }

    processGameResult(gameEndData) {
        const result = gameEndData.result;
        if (result === 1 || result === 2) {
            setTimeout(() => {
                const resultVal = gameEndData.resultVal;
                this.setState({winIndexes: resultVal}, () => {
                    setTimeout(() => {
                        const player = result === 1 ? this.playerUser : this.playerAI;
                        this.processGameEnd(gameEndData);
                        this.setState({winPlayer: player});
                    }, 400);
                });
            }, 100);
            return true;
        } else if (result === 3) {
            setTimeout(() => {
                this.processGameEnd(gameEndData);
                this.setState({isDraw: true});
            }, 200);
            return true;
        }
        return false;
    }

    processGameEnd(gameEndData) {
        this.endGameProcessStartTime = new Date().getTime();
        if (this.intervalFunc) {
            clearInterval(this.intervalFunc);
        }
        this.stopGameTimerAudio();

        // Vibration.vibrate(200);
        const isWin = gameEndData.result === 1;
        const isLose = gameEndData.result === 2;
        const isDraw = gameEndData.result === 3;

        if (isDraw) {
            if (this.gamePlayAudioIdNeutral) {
                this.gamePlayAudioIdNeutral.play();
            }
        } else if (isWin) {
            if (this.gamePlayAudioIdWin) {
                this.gamePlayAudioIdWin.play();
            }
        } else {
            if (this.gamePlayAudioIdLose) {
                this.gamePlayAudioIdLose.play();
            }
        }

        // const endGameValue = JSON.stringify({isWin: isWin, isLose: isLose, isDraw: isDraw});
        if (this.props.onEnd) {
            this.props.onEnd({isWin: isWin, isLose: isLose, isDraw: isDraw});
        }
    }

    getCardSize() {
        const uiConfigs = this.props.uiConfigs;
        const sizeFactor = uiConfigs.sizeFactor;
        const cardSpacing = this.getCardSpacing();

        const rows = this.props.rows;
        const columns = this.props.columns;
        const borderWidth = 32 * sizeFactor;
        const borderHeight = 36 * sizeFactor;
        const otherUiHeight = 200 * sizeFactor;

        const possibleWidth = (this.props.contentWidth - 2 - (borderWidth * sizeFactor) - (columns + 1) * cardSpacing) / columns; // viewMargin, borderWidth, margin to each card
        const possibleHeight = (this.props.contentHeight - otherUiHeight - 2 - (borderHeight * sizeFactor) - (rows + 1) * cardSpacing) / rows; // viewMargin, borderWidth, margin to each card
        const possibleSize = Math.min(possibleWidth, possibleHeight);
        const maxCardSize = this.props.maxCardSize || 250;
        const cardSize = Math.floor(Math.min(maxCardSize, possibleSize));
        return cardSize;
    }

    getCardSpacing() {
        return 0;
    }
}

const PlayerScoreView = React.memo((props) => {
   const {uiConfigs, isLTR, playerUser, playerAI, showFetchLoading, fetchingAi,
       onImageClicked} = props;
   let {userWonRounds, aiWonRounds} = props;
   const sizeFactor = uiConfigs.sizeFactor;
   const onPlayerUserImageClickedL = () => {
       onImageClicked(playerUser.imageUrl);
   }
   userWonRounds = userWonRounds || '0';
   aiWonRounds = aiWonRounds || '0';

   return (
     <View style={{flexDirection: 'row', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 20 * sizeFactor, margin: 20 * sizeFactor, marginBottom: 8 * sizeFactor}}>
         <ImageBackground source={isLTR ? uiConfigs.gameBgTopLeftImage : uiConfigs.gameBgTopRightImage} resizeMode="fill" style={{height: 44 * sizeFactor, minWidth: 160 * sizeFactor, flexDirection: 'row', display: 'flex', alignItems: 'center', paddingLeft: 12 * sizeFactor, paddingRight: 12 * sizeFactor, paddingBottom: 2}} >
             {playerUser.imageUrl ?
               <TouchableOpacity onClick={onPlayerUserImageClickedL}>
                   <AppImage imageUrl={playerUser.imageUrl} style={{width: 30 * sizeFactor, height: 30 * sizeFactor, borderRadius: 8}}/>
               </TouchableOpacity>
               : <AppImage source={playerUser.image} style={{width: 30 * sizeFactor, height: 30 * sizeFactor, borderRadius: 4}}/>
             }
             <View style={{position: 'relative', flex: 1, flexDirection: 'row'}}>
                 <AppText fontSizeN={uiConfigs.fontSize} align={'center'} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, display: 'flex', flex: 0.85, justifyContent: 'center'}}>
                     {locString('you')}
                 </AppText>
                 <AppText fontSizeN={uiConfigs.fontSize} align={'center'} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, display: 'flex', flex: 1.15, justifyContent: 'center'}}>
                     {userWonRounds}
                 </AppText>
             </View>
             {showFetchLoading && !fetchingAi ?
               <View style={{position: 'absolute', left: 0, right: 0, top: 0, bottom: 0}}>
                 <Skeleton variant={'rect'} style={{width: '100%', height: '100%', borderRadius: 22 * sizeFactor, backgroundColor: AppUtils.colorWithAlpha(ColorBlack, 0.3)}}/>
               </View>
               : null
             }
         </ImageBackground>
         <View style={{alignItems: 'center', minWidth: 28 * sizeFactor}}>
             <AppText fontSizeN={uiConfigs.fontSize} variant={'h6'} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, marginLeft: 12, marginRight: 12}}>
                 {'VS'}
             </AppText>
         </View>
         <ImageBackground source={isLTR ? uiConfigs.gameBgTopRightImage : uiConfigs.gameBgTopLeftImage} resizeMode="fill" style={{height: 44 * sizeFactor, minWidth: 160 * sizeFactor, flexDirection: 'row', display: 'flex', alignItems: 'center', paddingLeft: 12 * sizeFactor, paddingRight: 12 * sizeFactor, paddingBottom: 2}} >
             <View style={{position: 'relative', flex: 1, flexDirection: 'row'}}>
                 <AppText fontSizeN={uiConfigs.fontSize} align={'center'} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, display: 'flex', flex: 1.15, justifyContent: 'center'}}>
                     {aiWonRounds}
                 </AppText>
                 <AppText fontSizeN={uiConfigs.fontSize} align={'center'} style={{fontWeight: FontWeightMedium, color: uiConfigs.gameValueTextColor, display: 'flex', flex: 0.85, justifyContent: 'center'}}>
                     {locString('bot')}
                 </AppText>
             </View>
             {playerAI.imageUrl ?
               <AppImage imageUrl={playerAI.imageUrl} style={{position: 'relative', width: 30 * sizeFactor, height: 30 * sizeFactor, borderRadius: 8}}/>
               : <AppImage source={playerAI.image} style={{position: 'relative', width: 30 * sizeFactor, height: 30 * sizeFactor, borderRadius: 8}}/>
             }
             {showFetchLoading && fetchingAi ?
               <View style={{position: 'absolute', left: 0, right: 0, top: 0, bottom: 0}}>
                 <Skeleton variant={'rect'} style={{width: '100%', height: '100%', borderRadius: 22 * sizeFactor, backgroundColor: AppUtils.colorWithAlpha(ColorBlack, 0.3)}}/>
               </View>
               : null
             }
         </ImageBackground>
     </View>
   );
});

// const CardsView = (props) => {
//     const {disabled, uiConfigs, cardSize, winIndexes, board, playerUser, playerAI,
//         onClick, refTouch} = props;
//
//     const cardViews = [];
//     for (let i = 0; i < board.length; i++) {
//         const onClickL = () => {
//             onClick(i);
//         }
//
//         let bgColor = ColorClear;
//         if (winIndexes && winIndexes.includes(i)) {
//             if (board[winIndexes[0]] === playerUser.id) {
//                 bgColor = ColorGreen;
//             } else {
//                 bgColor = ColorWhite;
//             }
//         }
//         let disabledL = true;
//         let imageUrl = null;
//         let image = null;
//         const playerId = board[i];
//         if (!playerId) {
//             disabledL = false;
//         } else if (playerId === playerUser.id) {
//             imageUrl = playerUser.imageUrl;
//             image = playerUser.image;
//         } else if (playerId === playerAI.id) {
//             imageUrl = playerAI.imageUrl;
//             image = playerAI.image;
//         }
//         cardViews.push(
//           <CardView
//             key={''+ i}
//             index={i}
//             refTouch={refTouch}
//             bgColor={bgColor}
//             imageUrl={imageUrl}
//             image={image}
//             playerId={playerId}
//             disabled={disabled || disabledL}
//             cardBgImage={i % 2 === 0 ? uiConfigs.cardBgEvenImage : uiConfigs.cardBgOddImage}
//             cardSize={cardSize}
//             onClick={onClickL}
//           />
//         );
//     }
//     return cardViews;
// };

const CardsView = React.memo((props) => {
  const {
    disabled,
    uiConfigs,
    cardSize,
    winIndexes,
    board,
    playerUser,
    playerAI,
    onClick,
    refTouch,
  } = props;

  return board.map((_, i) => {
    const onClickL = useCallback(() => onClick(i), [onClick, i]);

    const isWinningIndex = winIndexes && winIndexes.includes(i);
    const bgColor = isWinningIndex
      ? board[winIndexes[0]] === playerUser.id
        ? ColorGreen
        : ColorWhite
      : ColorClear;

    const playerId = board[i];
    let isDisabled = disabled || playerId != null;

    let imageUrl = null;
    let image = null;
    if (!playerId) {
      isDisabled = false;
    } else if (playerId === playerUser.id) {
      imageUrl = playerUser.imageUrl;
      image = playerUser.image;
    } else if (playerId === playerAI.id) {
      imageUrl = playerAI.imageUrl;
      image = playerAI.image;
    }

    return (
      <CardView
        key={i}
        index={i}
        refTouch={refTouch}
        bgColor={bgColor}
        imageUrl={imageUrl}
        image={image}
        playerId={playerId}
        disabled={isDisabled}
        cardBgImage={i % 2 === 0 ? uiConfigs.cardBgEvenImage : uiConfigs.cardBgOddImage}
        cardSize={cardSize}
        onClick={onClickL}
      />
    );
  });
});

const CardView = (props) => {
    const {index, bgColor, imageUrl, image, disabled, cardBgImage, cardSize,
        onClick, refTouch} = props;
    const cardPadding = 8;

    const refTouchL = useCallback(
      (ref) => {
        if (refTouch) {
          refTouch(ref, index);
        }
      },
      [refTouch, index]
    );

    return (
      <TouchableOpacity
        ref={refTouchL}
        disabled={disabled}
        onClick={onClick}
        style={{width: cardSize, height: cardSize, opacity: 1}} >
          <ImageBackground source={cardBgImage} resizeMode="fill" style={{width: cardSize, height: cardSize, display: 'flex', alignItems: 'center', justifyContent: 'center'}} >
            <View style={{position: 'relative', width: cardSize-4, height: cardSize-4, alignItems: 'center', justifyContent: 'center', borderRadius: RadiusView, borderWidth: 1, borderColor: bgColor, backgroundColor: bgColor}}>
              <View style={{width: cardSize - 2 * cardPadding, height: cardSize - 2 * cardPadding}}>
                {imageUrl || image ?
                  <View style={{flex: 1, alignItems: 'center', justifyContent: 'center'}}>
                    {imageUrl ?
                      <AppImage imageUrl={imageUrl} style={{width: cardSize - 2 * cardPadding, height: cardSize - 2 * cardPadding, borderRadius: RadiusView}}/>
                      : <AppImage source={image} style={{width: cardSize - 2 * cardPadding, height: cardSize - 2 * cardPadding, borderRadius: RadiusView}}/>
                    }
                  </View>
                  : null
                }
              </View>
            </View>
          </ImageBackground>
      </TouchableOpacity>
    );
};
